import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import {
  BannerComponent,
  ButtonComponent,
  ButtonLinkComponent,
  IconComponent,
  BadgeComponent,
  IconButtonComponent,
  LogoButtonComponent,
  SearchInputComponent,
  TooltipWrapperComponent,
} from '@mode/capra';

export const DowngradedCapraModule = angular
  .module('downgraded-capra-components', [])
  .directive('capraBanner', downgradeComponent({ component: BannerComponent }))
  .directive('capraButton', downgradeComponent({ component: ButtonComponent }))
  .directive('capraButtonLink', downgradeComponent({ component: ButtonLinkComponent }))
  .directive('capraIcon', downgradeComponent({ component: IconComponent }))
  .directive('capraBadge', downgradeComponent({ component: BadgeComponent }))
  .directive('capraIconButton', downgradeComponent({ component: IconButtonComponent }))
  .directive('capraLogoButton', downgradeComponent({ component: LogoButtonComponent }))
  .directive('capraSearchInput', downgradeComponent({ component: SearchInputComponent }))
  .directive('capraTooltip', downgradeComponent({ component: TooltipWrapperComponent })).name;
